import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useFamily } from '../../../context/FamilyContext';
import './ChildCard.css';
import MyButton from '../../basic/MyButton';
import DepositModal from './modalDepositFundsChild';
import { fetchChildTotalBalance } from '../../../api';
import placeholderAvatar from '../../../assets/Avatars/placeholder/placeholder.png';
import { currencies } from '../../basic/currencies';

const avatarContext = require.context('../../../assets/Avatars', false, /\.(png|jpe?g|svg)$/);
const avatars = Object.fromEntries(
  avatarContext.keys().map(key => [key.replace('./', ''), avatarContext(key)])
);

function ChildCard({ child, showNotification }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [localTotalBalance, setLocalTotalBalance] = useState(child.totalAccountsBalance);
    const navigate = useNavigate();
    const location = useLocation();
    const { refreshChildTotalBalance, currencyCode } = useFamily();
    const isMobile = useMediaQuery({ maxWidth: 640 });

    const getCurrencySymbol = useCallback(() => {
        const currency = currencies.find(c => c.code === currencyCode);
        return currency ? currency.symbol : '$'; // Default to '$' if not found
    }, [currencyCode]);

    // Sync with context when navigating back to the page
    useEffect(() => {
        const syncBalance = async () => {
            try {
                const data = await fetchChildTotalBalance(child.childId);
                setLocalTotalBalance(data.totalBalance);
            } catch (error) {
                console.error("Failed to sync balance:", error);
            }
        };
        syncBalance();
    }, [location.pathname, child.childId]);

    const refreshBalance = useCallback(async () => {
        try {
            const data = await fetchChildTotalBalance(child.childId);
            setLocalTotalBalance(data.totalBalance);
            showNotification('Deposit successful!', 'success');
        } catch (error) {
            console.error("Failed to refresh balance:", error);
            showNotification('Failed to refresh balance.', 'error');
        }
    }, [child.childId, showNotification]);

    const handleCardClick = () => {
        if (!isModalOpen) {
            navigate(`/family/${child.name}`);
        }
    };

    const handleButtonClick = (e) => {
        e.stopPropagation();
        setIsModalOpen(true);
    };

    return (
        <div className="child-card" onClick={handleCardClick}>
            <div className="child-info">
                <img 
                    src={avatars[child.avatarUrl] || placeholderAvatar} 
                    alt={`${child.name}'s Avatar`}
                    className="avatar"
                />
                <div className="child-details">
                    <h3>{child.display_name}</h3>
                    <p>Accounts Balance: <strong>{getCurrencySymbol()}{localTotalBalance.toLocaleString('en-US')}</strong></p>
                    <p>Weekly Allowance: <strong>{getCurrencySymbol()}{child.weeklyAllowance.toLocaleString('en-US')}</strong> ({child.dayofweek})</p>
                </div>
            </div>
            <MyButton 
                text="Deposit Funds" 
                onClick={handleButtonClick} 
                backgroundColor="#007BFF" 
                size={isMobile ? "small" : "medium"}
            />
            <DepositModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                childId={child.childId}
                childName={child.display_name}
                onDepositSuccess={refreshBalance}
            />
        </div>
    );
}

export default ChildCard;